import type { MessageInterface } from '@nts/std/interfaces';
import { MessageType } from '@nts/std/types';

export class Message<T> implements MessageInterface<T> {
    constructor(
        public data: T,
        public type = MessageType.Message,
        public uuid = ''
    ) {

    }
}
